import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";
import CommonDatePicker from "../../../components/CommonDatePicker";
import SelectBox from "../../../components/SelectBox";
import { groupUsers } from "../../redux/api/dummyJson";

const SiteUserReport = () => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const handlePreview = () => {
    console.log("From:", fromDate);
    console.log("To:", toDate);
    console.log("Company:", selectedCompany);
    console.log("Site:", selectedOption);
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"User"} type={"Report"} />
      <div className={"d-flex gap-5"}>
        <CommonDatePicker
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        <div className="w-100 ">
          <label className="form-label">Select Group User</label>
          <SelectBox
            arrayData={groupUsers}
            selectedOption={selectedUser}
            setSelectedOption={setSelectedUser}
            style={true}
          />
        </div>

        {/* Preview Button */}
        <div className="col-md- mt-4 d-flex flex-row flex-end">
          <button
            onClick={handlePreview}
            className="submit-btn"
            disabled={
              !fromDate ||
              !toDate ||
              !selectedCompany?.label ||
              !selectedOption?.label
            }
          >
            Preview
          </button>
        </div>
      </div>
    </div>
  );
};

export default SiteUserReport;
